<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/media-pricing/event' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.CreateEvent") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EventCode')"
              >
                <vs-input
                  v-model="eventCode"
                  :placeholder="$t('setup.label.EnterEventCode')"
                  :label="$t('setup.label.EventCode')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EventDescription')"
              >
                <vs-input
                  v-model="eventDescription"
                  :placeholder="$t('setup.label.EnterEventDescription')"
                  :label="$t('setup.label.EventDescription')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.EventCategory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EventCategory')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="eventCategory"
                    :options="eventTemplateData.eventCategeorydata"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(status) => status.mCodeValue"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ChargeCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="chargeDescription"
                    v-model="chargeCode"
                    :options="eventTemplateData.chargeData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(data) => data.chargeCode"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.chargeDescription
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.StartDate")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.StartDate')"
                >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="startDate"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.EndDate")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EndDate')"
                >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="endDate"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.Validity")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Validity')"
                >
                  <datepicker
                    :placeholder="$t('setup.label.SelectEventValidity')"
                    v-model="validity"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Status") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Status')"
                >
                  <v-select
                    label="value"
                    v-model="status"
                    :options="eventTemplateData.statusData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(status) => status.id"
                  >
                    <template v-slot:option="option">{{
                      option.value
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SelectedMediaService") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SelectedMediaService')"
                >
                  <v-select
                    label="mediaTitle"
                    v-model="availableMedia"
                    :options="eventTemplateData.mediaAsset"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    multiple
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(availableMedia) => availableMedia.mediaId"
                  >
                    <template v-slot:option="option">{{
                      option.mediaTitle
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SelectedMediaService") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="selected media service"
                >
                  <v-select
                    v-model="selectedMediaService"
                    class="w-full mb-5 font-semibold starlabel"
                    multiple
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div> -->
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="createEvent">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      eventCode: "",
      eventDescription: "",
      validity: "",
      // selectedMediaService: "",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      chargeCode: "",
      eventCategory: "",
      status: "",
      availableMedia: [],
      startDate: "",
      endDate: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      eventTemplateData: (state) => state.mediaDetails.eventTemplate,
    }),
  },
  methods: {
    async getEventTemplateData() {
      try {
        await this.$store.dispatch("mediaDetails/getEventTemplateAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createEvent() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
      const formattedStartDate = moment(this.startDate).format(
        "dd MMMM yyyy HH:mm:ss"
      );
      const formattedEndDate = moment(this.endDate).format(
        "dd MMMM yyyy HH:mm:ss"
      );
      const formattedValidity = moment(this.validity).format("DD MMMM YYYY");

      let payload = {
        status: this.status,
        eventName: this.eventCode,
        eventDescription: this.eventDescription,
        eventCategory: this.eventCategory,
        chargeCode: this.chargeCode,
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        eventStartDate: formattedStartDate,
        eventEndDate: formattedEndDate,
        eventValidity: formattedValidity,
        mediaData: this.availableMedia,
      };

      await this.$store.dispatch("mediaDetails/createEventAction", payload);
      this.$router.push("/setup/media-pricing/event");
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Event created Successfully!",
        type: "success",
      });
      this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.eventCode = "";
      this.eventDescription = "";
      this.validity = "";
      this.chargeCode = "";
      this.eventCategory = "";
      this.status = "";
      this.availableMedia = [];
      this.startDate = "";
      this.endDate = "";
      this.$refs.observer.reset();
    },
  },
  watch: {
    // availableMedia(val) {
    //   this.selectedMediaService = val;
    // },
  },

  mounted() {
    this.getEventTemplateData();
  },
};
</script>
